<template>
  <b-form-group
    :label="label || `Mobile Phone${required ? '*' : ''}:`"
    :label-for="makeId('mobile_phone')"
    :state="state"
    :invalid-feedback="invalid"
    :description="description"
  >
    <VueTelInput
      ref="telInput"
      :default-country="SchoolSettings.country.alpha_2_code"
      :auto-default-country="false"
      :value="formattedNumber"
      :disabled="disabled"
      :mode="
        SchoolSettings.is_international_mobile_phone_format ? 'international' : 'national'
      "
      :input-options="{
        id: makeId('mobile_phone'),
        name: makeName('mobile_phone'),
        styleClasses: { 'is-invalid': state === false, 'form-control': true },
        autocomplete: 'nope',
        placeholder: 'Enter a phone number',
      }"
      :style-classes="{ 'is-invalid': state === false }"
      @input="onInput"
    />
  </b-form-group>
</template>

<script>
import FormFieldsMixin from "@/mixins/FormFieldsMixin";

export default {
  name: "MobilePhoneInput",
  components: {
    VueTelInput: () => import("./VueTelInput.vue"),
  },
  mixins: [FormFieldsMixin],
  props: {
    value: String,
    state: Boolean,
    invalid: String,
    prefix: String,
    required: { required: false, default: false, type: Boolean },
    disabled: Boolean,
    label: String,
    description: String,
  },
  emits: ["input"],
  data: function () {
    return {
      // Number to display.
      formattedNumber: this.value,
      // Number to store.
      internalNumber: this.value,
    };
  },
  watch: {
    value(newValue) {
      // value props must be always in e164 format
      // but we want display formatted number to user when it valid
      // so we have formattedNumber that represent initial value and updated
      // by vue-tel-input on it's own and we have internalNumber that represent
      // current value in e164. internalNumber should always match value prop
      // if it doesn't match that mean the prop was updated not by us and
      // we must update internalNumber
      if (newValue !== this.internalNumber) {
        this.formattedNumber = newValue;
        this.internalNumber = newValue;
      }
    },
  },
  methods: {
    onInput(_, value) {
      if (!this.$refs.telInput.finishMounted) {
        // Do nothing until VueTelInput is ready
        return;
      }
      this.internalNumber = value.number || value.formatted;
      this.formattedNumber = value.formatted;
      this.$emit("input", this.internalNumber);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/bootstrap-site-variables";

:deep(.vue-tel-input) {
  border-radius: $border-radius !important;
  background-color: $input-bg !important;
  border-color: $input-border-color !important;
}
</style>
